const nsValidator = (value) => {
  if (!value) return "validate.ns_empty";
  const regex = /^(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}$/;
  return regex.test(value) ? true : "validate.ns_failed";
};

export { nsValidator };
